import { useState } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';

import googleMapsWrapperConfig from '../../config/googleMapsWrapperConfig';
import FapAppProvider from '../../context/fap-app.context';

import FapEstimatePage from './EstimatePage';
import FapHomePage from './HomePage';
import NodePage from './NodePage';
import FapResultsPage from './ResultsPage';
import ThankYouPage from './ThankYouPage';

const FapApp = ({ page }) => {
  const [v, setV] = useState(null);
  const currentPage =
    page ||
    window?.drupalSettings?.findAProData?.settings?.currentPage
      .split('/')
      .pop();
  return (
    <Wrapper {...googleMapsWrapperConfig} callback={(c) => setV(c)}>
      {v === 'SUCCESS' && (
        <FapAppProvider>
          {currentPage === 'find-a-pro' && <FapHomePage />}
          {currentPage === 'results' && <FapResultsPage />}
          {currentPage === 'get-an-estimate' && <FapEstimatePage />}
          {currentPage === 'thank-you' && <ThankYouPage />}
          {currentPage === 'node-page' && <NodePage />}
        </FapAppProvider>
      )}
    </Wrapper>
  );
};

export default FapApp;
